import { useMutation, useQuery } from '@/hooks'
import { DataResponse, DlResponse } from '@/models/api'
import { AuthMe } from '@/models/auth/auth'
import type { BillLocationValue } from '@/constants/bill-location'

export function useSignInWithUserAndPassword() {
  return useMutation<any, Error, { username: string; password: string }>(['login'], {
    url: `/auth/signin`,
    method: 'POST',
  })
}

export function useAuthSignOut() {
  return useMutation<any, Error>(['logout'], {
    url: `/auth/signout`,
    method: 'POST',
  })
}

export function useRefreshToken() {
  return useMutation<any, Error, { refreshToken: string }>(['refresh_token'], {
    url: `/auth/refresh`,
    method: 'POST',
  })
}

export const useGetUser = () => {
  return useQuery<DlResponse<AuthMe>>({
    queryKey: ['get_auth_me'],
    url: `/auth/me`,
  })
}

export const useChangePassword = () => {
  return useMutation<any, Error, { currentPassword: string; newPassword: string }>(['change_password'], {
    url: `/auth/change-password`,
    method: 'POST',
  })
}

export const useUpdateUserPreferences = () => {
  return useMutation<
    DlResponse<AuthMe>,
    Error,
    { default_location: BillLocationValue | null }
  >(['update_user_preferences'], {
    url: `/auth/me/preferences`,
    method: 'PATCH',
  })
}
